import { BALANCE_TOKEN_LIST } from 'constants/index';

/**
 * Get valid token symbols for a specific chain
 * Derived from BALANCE_TOKEN_LIST - single source of truth
 *
 * @param {number} chainId - The chain ID to get tokens for
 * @returns {string[]} Array of token symbols valid for this chain
 */
export const getTokensForChain = (chainId) => {
  return BALANCE_TOKEN_LIST.filter((token) => token.chains.includes(chainId)).map(
    (token) => token.symbol,
  );
};
